import { API_PATHS } from "../constants/api-paths";
import { Module } from "../types/sso.types";
import { IResponse, request } from "../core/api.client";

type IApiResponse = {
  [module: string]: {
    module: Module;
    v1: string;
  };
};

export const getUrlModuleMapping = async (): Promise<IResponse<IApiResponse>> => {
  const response = await request<IApiResponse>({
    method: "GET",
    url: API_PATHS.urlModuleMapping,
  });

  return response;
};
